import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import {
  flashcardPanelBodySx,
  flashcardPanelHeaderSx,
  flashcardPanelHeaderTitleSx,
  flashcardPanelOuterSx,
} from "./styles";

export function FlashcardPanel({
  sectionTitle,
  highlighted,
  onBodyMouseDown,
  children,
}: {
  sectionTitle: string;
  highlighted?: boolean;
  onBodyMouseDown?: React.MouseEventHandler<HTMLDivElement>;
  children: React.ReactNode;
}) {
  const theme = useTheme();
  return (
    <Box sx={flashcardPanelOuterSx}>
      <Box sx={flashcardPanelHeaderSx(theme)}>
        <Typography
          variant="body2"
          fontWeight={600}
          sx={flashcardPanelHeaderTitleSx(theme)}
        >
          {sectionTitle}
        </Typography>
      </Box>
      <Box
        onMouseDown={onBodyMouseDown}
        sx={flashcardPanelBodySx(!!highlighted, theme)}
      >
        {children}
      </Box>
    </Box>
  );
}
